module.exports = __webpack_public_path__ + "img/f3.eadf4239.png";